import React from 'react';

import './NoPressContent.scss';
import { string } from 'prop-types';

const NoPressContent = ({ text }) => (
  <div className="no-press-content">
    <div>{text}</div>
  </div>
);

NoPressContent.propTypes = {
  text: string,
};

NoPressContent.defaultProps = {
  text: null,
};

export default NoPressContent;
